var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecommendedItem',{attrs:{"title":_vm.$t('LandingPage.recommended_items_topics_title')}},[_c('PackageCloud')],1)}
var staticRenderFns = []

export { render, staticRenderFns }